import { useEffect, useRef } from "react";
import { useGame } from "../app/GameProvider.js";

export function PhaseTutorial() {
  const { state, dispatch } = useGame();
  const dialogRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (state.overlay !== "phaseTutorial") return;
    dialogRef.current?.focus();
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") dispatch({ type: "CLOSE_OVERLAY" });
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [state.overlay, dispatch]);

  if (state.overlay !== "phaseTutorial") return null;

  return (
    <div className="overlay phase-tutorial" role="presentation">
      <div ref={dialogRef} className="dialog phase-tutorial-dialog" role="dialog" aria-modal="true" aria-label="プロジェクト（PJ）の進め方" tabIndex={-1}>
        <header>
          <img src="/secretary.png" alt="" />
          <h2>プロジェクト（PJ）の進め方</h2>
        </header>
        <ul>
          <li>手札の施策カードは、行動回数だけ使うことができます。</li>
          <li>行動が終わったら、施策フェーズを終了して、労働者の進捗を合計します。</li>
          <li>期限までこれを繰り返して、進捗を100%にしましょう！</li>
          <li>プロジェクトでは色んなハプニングが発生するので気をつけてください。疲労が10になったらゲームオーバーです。</li>
        </ul>
        <button type="button" className="btn btn-primary" onClick={() => dispatch({ type: "CLOSE_OVERLAY" })}>プロジェクト開始！</button>
      </div>
    </div>
  );
}
